import controller from './sca.controller';
import template from './sca.html';

const scaComponent = {
  restrict: 'E',
  bindings: {
    scaType: '=',
    onScaCompleted: '&?'
  },
  template,
  controller
};

export default scaComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/sca/sca.component.js
 **/